function noop(...params: any): any {}

export default {
  init: noop,
  encrypt: noop,
  cca_continue: noop,
};
